import { render, staticRenderFns } from "./FetchContainer.vue?vue&type=template&id=f547e134&"
import script from "./FetchContainer.vue?vue&type=script&lang=js&"
export * from "./FetchContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports